import isEqual from 'lodash/isEqual';

export const selectIsDraftDirty = (state) => {
  const draft = state.profile?.information;
  const saved = state.profile?.user;
  if (!draft || !saved) return false;
  return !isEqual(draft, saved);
};


